// removed by extract-text-webpack-plugin
module.exports = {"container":"_2NHrc","card":"_2V29l","cover":"_9wQqc","placeHolderShimmer":"_1f8kk","photo":"_3UEaY","image":"_3PhOY","flexContainer":"_3fv7W","userInfo":"_1OQ6I","name":"_2K6a_","date":"_1zceZ","stats":"H_rsW","section":"_1I7lP","smallCount":"_2jGqv","smallLabel":"_3w8J7","count":"_2aSAi","label":"AkqRq"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile-placeholder/profile-placeholder.scss
// module id = 1774
// module chunks = 0